/**
 * @generated SignedSource<<f5ecb5e05aeb1939fbc27623b1b7a025>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PermissionsProvider_user$data = {
  readonly account: {
    readonly id: number;
    readonly timesheets_protected: boolean | null | undefined;
  };
  readonly email: string;
  readonly id: number;
  readonly linkedPerson: {
    readonly id: number;
  } | null | undefined;
  readonly manageable_people: ReadonlyArray<{
    readonly id: number;
    readonly person: {
      readonly id: number;
    };
  }>;
  readonly manageable_projects: ReadonlyArray<{
    readonly id: number;
    readonly project: {
      readonly id: number;
    };
  }>;
  readonly permissions: any;
  readonly " $fragmentType": "PermissionsProvider_user";
};
export type PermissionsProvider_user$key = {
  readonly " $data"?: PermissionsProvider_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PermissionsProvider_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PermissionsProvider_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timesheets_protected",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_managers",
      "kind": "LinkedField",
      "name": "manageable_projects",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "projects",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "people_managers",
      "kind": "LinkedField",
      "name": "manageable_people",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "people",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "people",
      "kind": "LinkedField",
      "name": "linkedPerson",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "5d319f2e8b391837d51f2becc4325a7f";

export default node;
